import { FeaturesComparison } from './FeaturesComparison';

export default FeaturesComparison;
